export default __webpack_public_path__ + "static/b42-a3a24734bac90186c727eb0fceee0a6e.png";